/*
 Copyright (c), CKSource Holding sp. z o.o. All rights reserved.
 */

import { IDescriptorBody } from '../../../descriptor';
import PackageDataMessage, { IPackageDataMessage } from './packagedatamessage';

import ParserUtils, { MessageDataTypes } from './../parserutils';

export interface IObjectObjectPacketDataMessage extends IPackageDataMessage {
	data?: string;
	data1?: string;
}

export default class ObjectObjectPacketDataMessage extends PackageDataMessage {
	public static readonly TYPE: number =
		/* #__PURE__ -- @preserve */ ( () => ParserUtils.getPacketType( MessageDataTypes.OBJECT, MessageDataTypes.OBJECT ) )();

	public static readonly DESCRIPTOR_NAME: string = 'ObjectObjectPacketDataMessage';

	public static readonly DESCRIPTOR: IDescriptorBody = /* #__PURE__ -- @preserve */ ( () => ( {
		fields: {
			data: {
				type: 'string',
				id: 1
			},
			data1: {
				type: 'string',
				id: 2
			}
		}
	} ) )();

	public constructor( public readonly data: Record<string, unknown>, public readonly data1: Record<string, unknown> ) {
		super();
	}

	public toJSON(): IObjectObjectPacketDataMessage {
		return {
			data: this.data ? JSON.stringify( this.data ) : undefined,
			data1: this.data1 ? JSON.stringify( this.data1 ) : undefined
		};
	}

	public static fromJSON( data: IObjectObjectPacketDataMessage ): ObjectObjectPacketDataMessage {
		return new ObjectObjectPacketDataMessage( data.data && JSON.parse( data.data ), data.data1 && JSON.parse( data.data1 ) );
	}

	public static create( data: Record<string, unknown>, data1: Record<string, unknown> ): ObjectObjectPacketDataMessage {
		return new ObjectObjectPacketDataMessage( data, data1 );
	}
}
